webpackJsonp([2],{

/***/ "./lib/Hit/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return License; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Deprecated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Owner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Downloads; });
/* unused harmony export Links */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_esm__ = __webpack_require__("../../node_modules/date-fns/esm/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./lib/util.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var License = function License(_ref) {
  var type = _ref.type;
  return type ? _jsx('span', {
    className: 'ais-Hit--license'
  }, void 0, type) : null;
};

var Deprecated = function Deprecated(_ref2) {
  var deprecated = _ref2.deprecated;
  return deprecated ? _jsx('span', {
    className: 'ais-Hit--deprecated',
    title: deprecated
  }, void 0, window.i18n.deprecated) : null;
};

var Owner = function Owner(_ref3) {
  var link = _ref3.link,
      avatar = _ref3.avatar,
      name = _ref3.name;
  return _jsx('a', {
    className: 'ais-Hit--ownerLink',
    href: link
  }, void 0, _jsx('img', {
    width: '20',
    height: '20',
    className: 'ais-Hit--ownerAvatar',
    src: 'https://res.cloudinary.com/hilnmyskv/image/fetch/w_40,h_40,f_auto,q_80,fl_lossy/' + avatar
  }), name);
};

var Downloads = function Downloads(_ref4) {
  var downloads = _ref4.downloads,
      humanDownloads = _ref4.humanDownloads;
  return _jsx('span', {
    className: 'ais-Hit--popular ' + Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* getDownloadBucket */])(downloads),
    title: window.i18n.downloads_in_last_30_days.replace('{count}', downloads.toLocaleString(window.i18n.active_language))
  }, void 0, humanDownloads);
};

var Links = function Links(_ref5) {
  var name = _ref5.name,
      homepage = _ref5.homepage,
      githubRepo = _ref5.githubRepo,
      className = _ref5.className;
  return _jsx('div', {
    className: className
  }, void 0, _jsx('span', {
    className: 'ais-Hit--link-npm'
  }, void 0, _jsx('a', {
    href: 'https://www.npmjs.com/package/' + name,
    title: window.i18n.npm_page_for.replace('{name}', name)
  }, void 0, window.i18n.npm)), githubRepo ? _jsx('span', {
    className: 'ais-Hit--link-github'
  }, void 0, _jsx('a', {
    title: window.i18n.github_repo_of.replace('{name}', name),
    href: 'https://github.com/' + Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* encode */])(githubRepo.user) + '/' + Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* encode */])(githubRepo.project) + githubRepo.path
  }, void 0, window.i18n.github)) : null, homepage ? _jsx('span', {
    className: 'ais-Hit--link-homepage'
  }, void 0, _jsx('a', {
    title: 'Homepage of ' + name,
    href: homepage
  }, void 0, window.i18n.homepage)) : null);
};

var Hit = function Hit(_ref6) {
  var hit = _ref6.hit,
      onTagClick = _ref6.onTagClick;
  return _jsx('div', {
    className: 'ais-Hits--item'
  }, void 0, _jsx('a', {
    className: 'ais-Hit--name',
    href: Object(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* packageLink */])(hit.name)
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__["Highlight"], {
    attributeName: 'name',
    hit: hit
  })), _jsx(Downloads, {
    downloads: hit.downloadsLast30Days,
    humanDownloads: hit.humanDownloadsLast30Days
  }), _jsx(License, {
    type: hit.license
  }), _jsx(Deprecated, {
    deprecated: hit.deprecated
  }), _jsx('span', {
    className: 'ais-Hit--version'
  }, void 0, hit.version), _jsx('p', {
    className: 'ais-Hit--description'
  }, void 0, hit.deprecated ? hit.deprecated : _jsx(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* HighlightedMarkdown */], {
    attributeName: 'description',
    hit: hit
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Owner, hit.owner), _jsx('span', {
    className: 'ais-Hit--lastUpdate',
    title: window.i18n.last_updated.replace('{update_date}', new Date(hit.modified).toLocaleDateString(window.i18n.active_language))
  }, void 0, window.i18n.time_ago.replace('{time_distance}', Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm__["a" /* formatDistance */])(new Date(hit.modified), new Date()))), Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* isEmpty */])(hit.keywords) ? null : _jsx('span', {
    className: 'ais-Hit--keywords hidden-sm-down'
  }, void 0, Object(__WEBPACK_IMPORTED_MODULE_3__util__["d" /* formatKeywords */])(hit.keywords, hit._highlightResult.keywords, 4, onTagClick)), _jsx(Links, {
    className: 'ais-Hit--links',
    name: hit.name,
    homepage: hit.homepage,
    githubRepo: hit.githubRepo
  }));
};

/* harmony default export */ __webpack_exports__["e"] = (Hit);

/***/ }),

/***/ "./lib/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return algolia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return docsearch; });
var algolia = {
  appId: 'OFCNCOG2CU',
  apiKey: 'f54e21fa3a2a0160595bb058179bfb1e',
  indexName: 'npm-search'
};

var docsearch = {
  apiKey: '3949f721e5d8ca1de8928152ff745b28',
  indexName: 'yarnpkg'
};

/***/ }),

/***/ "./lib/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatKeywords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return encode; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getDownloadBucket;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Keywords; });
/* harmony export (immutable) */ __webpack_exports__["h"] = packageJSONLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return packageLink; });
/* unused harmony export searchLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return prefixURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightedMarkdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return safeMarkdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unfetch__ = __webpack_require__("../../node_modules/unfetch/dist/unfetch.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__("../../node_modules/marked/lib/marked.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xss__ = __webpack_require__("../../node_modules/xss/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_xss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_unescape_html__ = __webpack_require__("../../node_modules/unescape-html/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_unescape_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_unescape_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags__ = __webpack_require__("../../node_modules/react-instantsearch/src/core/highlightTags.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors__ = __webpack_require__("../../node_modules/react-instantsearch/connectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors__);


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









var isEmpty = function isEmpty(item) {
  return typeof item === 'undefined' || item.length < 1;
};

var encode = function encode(val) {
  return encodeURIComponent(val);
};

function getDownloadBucket(dl) {
  if (dl < 1000) {
    return null;
  } else if (dl < 5000) {
    return 'hot-t1';
  } else if (dl < 25000) {
    return 'hot-t2';
  } else if (dl < 1000000) {
    return 'hot-t3';
  } else {
    return 'hot-t4';
  }
}

var Keywords = function Keywords(_ref) {
  var _ref$keywords = _ref.keywords,
      keywords = _ref$keywords === undefined ? [] : _ref$keywords,
      _ref$maxKeywords = _ref.maxKeywords,
      maxKeywords = _ref$maxKeywords === undefined ? 4 : _ref$maxKeywords;

  return isEmpty(keywords) ? null : _jsx('span', {
    className: 'ais-Hit--keywords hidden-sm-down'
  }, void 0, keywords.slice(0, maxKeywords).map(function (keyword) {
    return _jsx('a', {
      href: searchLink(keyword)
    }, name + '-' + keyword, keyword);
  }).reduce(function (prev, curr) {
    return [prev, ', ', curr];
  }));
};

function formatKeywords() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var highlightedKeywords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var maxKeywords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
  var _onClick = arguments[3];

  if (isEmpty(keywords)) return keywords;
  highlightedKeywords.forEach(function (el, i) {
    el.originalValue = keywords[i];
  });
  return highlightedKeywords.sort(function (k1, k2) {
    // sort keywords by match level
    if (k1.matchLevel !== k2.matchLevel) {
      if (k1.matchLevel === 'full') return -1;
      if (k2.matchLevel === 'full') return 1;
      return k1.matchLevel === 'partial' ? -1 : 1;
    }
    if (k1.matchedWords.length !== k2.matchedWords.length) {
      return k2.matchedWords.length - k1.matchedWords.length;
    }
    if (k1.matchedWords.join('').length !== k2.matchedWords.join('').length) {
      return k2.matchedWords.join('').length - k1.matchedWords.join('').length;
    }
    return 0;
  }).slice(0, maxKeywords).map(function (_ref2, keywordIndex) {
    var highlightedKeyword = _ref2.value,
        keyword = _ref2.originalValue;

    var highlighted = parseHighlightedAttribute({
      highlightedValue: highlightedKeyword
    });
    var content = highlighted.map(function (v, i) {
      var key = 'split-' + i + '-' + v.value;
      if (v.isHighlighted) {
        return _jsx('em', {
          className: 'ais-Highlight__highlighted'
        }, key, v.value);
      }
      return _jsx('span', {
        className: 'ais-Highlight__nonHighlighted'
      }, key, v.value);
    });
    return _jsx('span', {
      className: 'ais-Hit--keyword',
      onClick: function onClick() {
        return _onClick(keyword);
      }
    }, '' + keyword + keywordIndex, content);
  }).reduce(function (prev, curr) {
    return [prev, ', ', curr];
  });
}

function parseHighlightedAttribute(_ref3) {
  var _ref3$preTag = _ref3.preTag,
      preTag = _ref3$preTag === undefined ? __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags___default.a.highlightPreTag : _ref3$preTag,
      _ref3$postTag = _ref3.postTag,
      postTag = _ref3$postTag === undefined ? __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags___default.a.highlightPostTag : _ref3$postTag,
      highlightedValue = _ref3.highlightedValue;

  var splitByPreTag = highlightedValue.split(preTag);
  var firstValue = splitByPreTag.shift();
  var elements = firstValue === '' ? [] : [{ value: firstValue, isHighlighted: false }];

  if (postTag === preTag) {
    var isHighlighted = true;
    splitByPreTag.forEach(function (split) {
      elements.push({ value: split, isHighlighted: isHighlighted });
      isHighlighted = !isHighlighted;
    });
  } else {
    splitByPreTag.forEach(function (split) {
      var splitByPostTag = split.split(postTag);
      elements.push({
        value: splitByPostTag[0],
        isHighlighted: true
      });

      if (splitByPostTag[1] !== '') {
        elements.push({
          value: splitByPostTag[1],
          isHighlighted: false
        });
      }
    });
  }

  return elements;
}

function packageJSONLink(_ref4) {
  var githubRepo = _ref4.githubRepo;

  if (githubRepo) {
    var user = githubRepo.user,
        project = githubRepo.project,
        path = githubRepo.path,
        head = githubRepo.head;


    return {
      packageJSONLink: prefixURL('package.json', {
        base: 'https://github.com',
        user: user,
        project: project,
        head: head ? 'tree/' + head : 'tree/master',
        path: path
      })
    };
  }
  return {};
}

var packageLink = function packageLink(name) {
  return window.i18n.url_base + '/package' + ( true ? '/' : '?') + name;
};

var searchLink = function searchLink(query) {
  return window.i18n.url_base + '/packages?q=' + query;
};

var prefixURL = function prefixURL(url, _ref5) {
  var base = _ref5.base,
      user = _ref5.user,
      project = _ref5.project,
      head = _ref5.head,
      path = _ref5.path;

  if (url.indexOf('//') > 0) {
    return url;
  } else {
    return new URL((path ? path.replace(/^\//, '') + '/' : '') + url.replace(/^(\.?\/?)/, ''), base + '/' + user + '/' + project + '/' + (path ? '' : head + '/'));
  }
};

var status = function status(res) {
  return new Promise(function (resolve, reject) {
    if (res.status >= 200 && res.status < 300) {
      // GitHub will return status 202 or 204 if things like contributor activity are
      // valid, but not yet computed, and will return an empty response
      if (res.status === 202 || res.status === 204) {
        reject(res);
      }
      resolve(res);
    } else {
      reject(res);
    }
  });
};

var get = function get(_ref6) {
  var url = _ref6.url,
      type = _ref6.type;
  return Object(__WEBPACK_IMPORTED_MODULE_1_unfetch__["a" /* default */])(url).then(status).then(function (res) {
    return res[type]();
  }).catch(function (err) {
    // in case it's a useless response by GitHub, tell the caller to retry
    if (err.status === 202 || err.status === 204) {
      throw 'retry';
    } else {
      console.warn(err);
    }
  });
};

var HighlightedMarkdown = Object(__WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors__["connectHighlight"])(function (_ref7) {
  var highlight = _ref7.highlight,
      attributeName = _ref7.attributeName,
      hit = _ref7.hit;
  return _jsx('span', {
    className: 'ais-Hit--keyword'
  }, void 0, highlight({
    attributeName: attributeName,
    hit: hit,
    highlightProperty: '_highlightResult'
  }).map(function (v, i) {
    return v.isHighlighted ? _jsx('em', {
      className: 'ais-Highlight__highlighted',
      dangerouslySetInnerHTML: safeMarkdown(v.value)
    }, 'split-' + i + '-' + v.value) : _jsx('span', {
      className: 'ais-Highlight__nonHighlighted',
      dangerouslySetInnerHTML: safeMarkdown(v.value)
    }, 'split-' + i + '-' + v.value);
  }));
});

var inlineRenderer = new __WEBPACK_IMPORTED_MODULE_2_marked___default.a.Renderer();
inlineRenderer.paragraph = function (text) {
  return text;
};

var safeMarkdown = function safeMarkdown(input) {
  return {
    __html: __WEBPACK_IMPORTED_MODULE_3_xss___default()(__WEBPACK_IMPORTED_MODULE_2_marked___default()(__WEBPACK_IMPORTED_MODULE_4_unescape_html___default()(input), { renderer: inlineRenderer }))
  };
};

/***/ }),

/***/ "./packages.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("../../node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_instantsearch_connectors__ = __webpack_require__("../../node_modules/react-instantsearch/connectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_instantsearch_connectors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_instantsearch_connectors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_Hit__ = __webpack_require__("./lib/Hit/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_util__ = __webpack_require__("./lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_config__ = __webpack_require__("./lib/config.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();










var FEATURED = ['babel-core', 'react', 'async', 'lodash', 'debug', 'qs'];

var FeaturedPackage = function FeaturedPackage(_ref) {
  var name = _ref.name,
      owner = _ref.owner,
      description = _ref.description,
      keywords = _ref.keywords;
  return _jsx('div', {
    className: 'pkg-featured-pkg'
  }, void 0, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__lib_Hit__["d" /* Owner */], owner), _jsx('a', {
    className: 'ais-Hit--name',
    href: Object(__WEBPACK_IMPORTED_MODULE_6__lib_util__["i" /* packageLink */])(name)
  }, void 0, name), _jsx('p', {}, void 0, description), _jsx(__WEBPACK_IMPORTED_MODULE_6__lib_util__["b" /* Keywords */], {
    keywords: keywords
  }));
};

FeaturedPackage.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  owner: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    avatar: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  }),
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  keywords: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string).isRequired
};

var FilterByIds = Object(__WEBPACK_IMPORTED_MODULE_4_react_instantsearch_connectors__["connectRefinementList"])(function () {
  return null;
});

var Hits = Object(__WEBPACK_IMPORTED_MODULE_4_react_instantsearch_connectors__["connectHits"])(function (_ref2) {
  var hits = _ref2.hits;

  var half = Math.floor(hits.length / 2);
  var groups = [hits.slice(0, half), hits.slice(half, hits.length)];
  return _jsx('div', {
    className: 'row'
  }, void 0, groups.map(function (packages, i) {
    return _jsx('div', {
      className: 'col-md-6'
    }, i, packages.map(function (pkg) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FeaturedPackage, _extends({}, pkg, { key: pkg.objectID }));
    }));
  }));
});

var _ref4 = _jsx(Hits, {});

var Featured = function Featured(_ref3) {
  var objectIDs = _ref3.objectIDs;
  return _jsx(__WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__["InstantSearch"], {
    appId: __WEBPACK_IMPORTED_MODULE_7__lib_config__["a" /* algolia */].appId,
    apiKey: __WEBPACK_IMPORTED_MODULE_7__lib_config__["a" /* algolia */].apiKey,
    indexName: __WEBPACK_IMPORTED_MODULE_7__lib_config__["a" /* algolia */].indexName
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__["Configure"], {
    hitsPerPage: 6,
    attributesToRetrieve: ['name', 'owner', 'description', 'keywords']
  }), _jsx(FilterByIds, {
    attributeName: 'objectID',
    defaultRefinement: objectIDs
  }), _ref4);
};

__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(_jsx(Featured, {
  objectIDs: FEATURED
}), document.getElementById('pkg-featured'));

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},["./packages.js"]);


// WEBPACK FOOTER //
// packages.ebbe0a60ef223b295363.js